import {
  BaseIcon
} from "./chunk-Z3LMOCJ7.mjs";

// src/icons/tokens/TokenETH.tsx
import { forwardRef } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var TokenETH = forwardRef(
  ({ variant = "mono", ...props }, ref) => /* @__PURE__ */ jsx(BaseIcon, { ...props, ref, children: variant === "mono" ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12 2v7.39l6.25 2.795zm0 0L5.75 12.185 12 9.39zm0 14.975V22l6.25-8.65zM12 22v-5.025L5.75 13.35z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "m12 15.81 6.25-3.625L12 9.39zm-6.25-3.625L12 15.81V9.39z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "m12 15.81-6.25-3.625L12 2l6.25 10.185zm-5.835-3.92L11.9 2.545V9.34zm-.085.255L11.9 9.56v5.96zM12.1 9.56v5.96l5.815-3.375zm0-.22 5.735 2.55L12.1 2.545z",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "m12 16.895-6.25-3.55L12 22l6.25-8.655zM6.45 13.97l5.45 3.1v4.45zm5.65 3.1v4.45l5.45-7.55z",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    )
  ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { fill: "#8FFCF3", d: "M12 2v7.39l6.25 2.795z" }),
    /* @__PURE__ */ jsx("path", { fill: "#CABCF8", d: "M12 2 5.75 12.185 12 9.39z" }),
    /* @__PURE__ */ jsx("path", { fill: "#CBA7F5", d: "M12 16.975V22l6.25-8.65z" }),
    /* @__PURE__ */ jsx("path", { fill: "#74A0F3", d: "M12 22v-5.025L5.75 13.35z" }),
    /* @__PURE__ */ jsx("path", { fill: "#CBA7F5", d: "m12 15.81 6.25-3.625L12 9.39z" }),
    /* @__PURE__ */ jsx("path", { fill: "#74A0F3", d: "M5.75 12.185 12 15.81V9.39z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#202699",
        d: "m12 15.81-6.25-3.625L12 2l6.25 10.185zm-5.835-3.92L11.9 2.545V9.34zm-.085.255L11.9 9.56v5.96zM12.1 9.56v5.96l5.815-3.375zm0-.22 5.735 2.55L12.1 2.545z",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#202699",
        d: "m12 16.895-6.25-3.55L12 22l6.25-8.655zM6.45 13.97l5.45 3.1v4.45zm5.65 3.1v4.45l5.45-7.55z",
        fillRule: "evenodd",
        clipRule: "evenodd"
      }
    )
  ] }) })
);
TokenETH.displayName = "ETH";
var TokenETH_default = TokenETH;

export {
  TokenETH_default
};
